import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ahaApi from "../../app/services/aha-api";

const initialState = {
  value: [],
  loading: false,
};

export const updateHomeHealths = createAsyncThunk(
  "homeHealth/updateHomeHealths",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.updateHomeHealthOrder(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const updateHomeHealthsSlice = createSlice({
  name: "updateHomeHealths",
  initialState,
  reducers: {
    clearUpdateHomeHealthResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateHomeHealths.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateHomeHealths.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(updateHomeHealths.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const updateHomeHealthList = (state) => state.updateHomeHealths.value;
export const updateHomeHealthLoader = (state) => state.updateHomeHealths.loading;
export const { clearUpdateHomeHealthResponse } = updateHomeHealthsSlice.actions;

export default updateHomeHealthsSlice.reducer;
